import { Suspense } from "react"
import { makeStyles } from "tss-react/mui"
import { Grid, Tooltip, Typography } from "@mui/material"
import { DashboardCardSkeleton } from "../../../../dashboards/components/DashboardCardSkeleton"
import { QueryErrorBoundary } from "../../../../../core/api/components/QueryErrorBoundary"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { MerchantHomeQuery, fetchTodaysControlCode } from "../merchantHomeApi"
import { CardUiParams } from "../../../../dashboards/components/DashboardCard"

const useStyles = makeStyles()((theme) => ({
    container: {
        color: theme.palette.tailwind.slate[700],
        background: theme.palette.tailwind.sky[200],
        borderRadius: "0.5rem",
        textAlign: "center",
        maxWidth: CardUiParams.WIDTH,
        padding: "1.5rem 1rem",
        [theme.breakpoints.down("xl")]: {
            width: CardUiParams.WIDTH_SM,
        },
    },
}))

function isValidControlCode(code: string | number | undefined) {
    if (code === undefined) return false
    if (typeof code === "number") return true

    return !Number.isNaN(Number(code))
}

export function ControlCodeContent() {
    const { merchantId } = useMerchant()
    const { classes } = useStyles()

    const todaysControlCode = useApiQuery(fetchTodaysControlCode, {
        queryName: MerchantHomeQuery.TODAYS_CONTROL_CODE,
        dependencies: {
            merchantId,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
    })

    return (
        <LocalizedStrict id="merchant-home-todays-control-code-tooltip" attrs={{ title: true }}>
            <Tooltip arrow title="This will be displayed on the proof of purchase (app) and the printed receipt">
                <Grid container flexDirection="column" gap={2} className={classes.container}>
                    <>
                        <LocalizedStrict id="merchant-home-todays-control-code">
                            <Typography variant="h6">Todays control code</Typography>
                        </LocalizedStrict>
                        {isValidControlCode(todaysControlCode.data?.receipt.controlCode) ? (
                            <Typography variant="h3" fontWeight={500}>
                                {todaysControlCode.data?.receipt.controlCode || 0}
                            </Typography>
                        ) : (
                            <Typography variant="h5" fontWeight={500}>
                                {todaysControlCode.data?.receipt.controlCode || ""}
                            </Typography>
                        )}
                    </>
                </Grid>
            </Tooltip>
        </LocalizedStrict>
    )
}

export function ControlCodeCard() {
    return (
        <QueryErrorBoundary>
            <Suspense
                fallback={
                    <>
                        <DashboardCardSkeleton isSmall />
                    </>
                }
            >
                <ControlCodeContent />
            </Suspense>
        </QueryErrorBoundary>
    )
}
